export default __webpack_public_path__ + "f0130fec8e39598f30bf9ee9fd8d6508.svg";